import { spacing, color } from '@upstox/upstox-ui';

export const ipoInfoCard: CSSFunction = ({ theme }) => ({
  backgroundColor: color(theme, 'ui1'),
  padding: spacing(theme, [24]),
  borderRadius: '8px',
});
